import { Pipe, PipeTransform } from '@angular/core';

import { filter } from 'lodash';

@Pipe({
  name: 'selectedFilter'
})
export class SelectedFilterPipe implements PipeTransform {

  transform(value: any, args?: any): any {    
    return filter(value,(_item)=>_item.checked && _item.value != -1);
  }

}



// WEBPACK FOOTER //
// ./src/app/filter-selection/selected-filter.pipe.ts